
import { defineComponent, SetupContext } from "vue";
import ApplianceItem from "@/components/search/ApplianceItem.vue";
import { Product } from "@/types/common";

export default defineComponent({
  name: "ApplianceList",
  components: { ApplianceItem },
  props: {
    /**
     * 機器リストに表示するデータの配列
     */
    list: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context: SetupContext) {
    const selectCheck = (id: number, checked: boolean) => {
      context.emit("select-check", id, checked);
    };
    const getNitcName = (product: Product) => {
      return product != null && product.nickname != null
        ? product.nickname
        : product.productName;
    };
    return {
      selectCheck,
      getNitcName
    };
  }
});
